module.exports = __webpack_public_path__ + "static/media/lidar.57357251.gif";